module.exports = __webpack_public_path__ + "img/ИФ-1(А)-025-m.e0b7819e.png";